import { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import classnames from "classnames"
import Logo from "components/logo"
import { useSaveContextPreferences } from "hooks/preferences"
import { LINK } from "../../shapes"
import MobileNavLinkGroup from "./mobile-nav-link-group"
import "./style.scss"

function MobileNav({ portfolioName, home, links }) {
  const [open, setOpen] = useState(false)

  const saveLastLocationPreference = useSaveContextPreferences("navigation.root")

  const toggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  return <div className={classnames("toggle", { open })} onClick={toggle}>
    <i className="fa fa-bars" />
    <div className={classnames("menu", { open })}>
      <div className="portfolio-name group">
        {portfolioName}
      </div>
      <Link to={home} className="mobile-link group">
        <Logo className="icon" />
        <div className="label">Home</div>
      </Link>
      {links.map(link =>
        <MobileNavLinkGroup key={link.id} link={link} onSaveLastLocation={saveLastLocationPreference} />,
      )}
      <div className="footer">
        <Logo className="logo" />
        <div className="brand">Omega Point</div>
        <div className="product">Portfolio Intelligence</div>
      </div>
    </div>
  </div>
}

MobileNav.propTypes = {
  links: PropTypes.arrayOf(LINK).isRequired,
  portfolioName: PropTypes.string.isRequired,
  home: PropTypes.string.isRequired,
}

export default MobileNav
